import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { ExternalLink } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo } from '@/components/Grid/components/Table/formatters';

import buildSiteUrl from '../../../utils/site-url';

export default function LinkEntity({ info, asLabel }) {
  const { row } = getInfo(info)

  const handleClick = useCallback(() => {
    const url = buildSiteUrl(row.route?.path)

    if (url) {
      window.open(url, '_blank')
    }
  }, [row])

  if (asLabel) {
    return <Link onClick={handleClick}>
      Go to site
    </Link>
  }

  return <DefaultTooltip content='View on site'>
    <Link onClick={handleClick}>
      <ExternalLink size={16} />
    </Link>
  </DefaultTooltip>
}
